const avatarSelector = ".rcd-avatar";
const avatarTones = ["teal", "amber", "blue", "green", "red", "slate"];
let avatarObserver;

const normaliseKey = (value) => (value || "").trim().toLocaleLowerCase();

const resolveAvatarKey = (avatar) => {
    const owner = avatar.closest("[data-staff-name], [data-name], [data-email], [data-id]");
    const visibleName = owner?.querySelector?.("strong")?.textContent;

    return normaliseKey(
        avatar.dataset.rcdAvatarKey ||
        avatar.getAttribute("aria-label") ||
        owner?.dataset.staffName ||
        owner?.dataset.name ||
        visibleName ||
        owner?.dataset.email ||
        owner?.dataset.id ||
        avatar.textContent
    );
};

const toneForKey = (key) => {
    let hash = 0;
    for (const character of key) {
        hash = ((hash << 5) - hash + character.codePointAt(0)) | 0;
    }

    return avatarTones[Math.abs(hash) % avatarTones.length];
};

const colourAvatar = (avatar) => {
    if (!(avatar instanceof HTMLElement)) {
        return;
    }

    const key = resolveAvatarKey(avatar);
    if (!key) {
        return;
    }

    avatar.dataset.rcdAvatarTone = toneForKey(key);
};

const colourAvatarsWithin = (root) => {
    if (!(root instanceof Element || root instanceof Document || root instanceof DocumentFragment)) {
        return;
    }

    if (root instanceof Element && root.matches(avatarSelector)) {
        colourAvatar(root);
    }
    root.querySelectorAll?.(avatarSelector).forEach(colourAvatar);
};

const observeAvatars = () => {
    if (avatarObserver || !document.body) {
        return;
    }

    avatarObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.target instanceof Element) {
                colourAvatar(mutation.target.closest(avatarSelector));
            }
            mutation.addedNodes.forEach(colourAvatarsWithin);
        });
    });
    avatarObserver.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["aria-label", "data-name", "data-staff-name", "data-rcd-avatar-key"]
    });
};

export const setupRcdAvatars = (root = document) => {
    colourAvatarsWithin(root);
    observeAvatars();
};
